import Header from "./sub-components/Header";
import Footer from './sub-components/Footer';
import { db } from './firebase/firebase';
import { doc, setDoc, getDocs, collection, query, addDoc, where, updateDoc } from "firebase/firestore";
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom'
import 'react-circular-progressbar/dist/styles.css';
import { useSelector } from "react-redux";
import { de_encrypt } from "../../encryption";
import BaseNav from "./sub-components/BaseNav"
const Index = (props) => {
    const user_key = de_encrypt(localStorage.getItem('user-key'));
    const [user_id, setId] = useState('')
    const [counter, setCounter] = useState(0);
    const [user, setUser] = useState(null);
    const [t_amt, setTamt] = useState();
    const [mine_amt, setMamt] = useState();
    const [ref_amt, setRamt] = useState(0);
    const [ref, setRef] = useState();
    const [shares, setShares] = useState();
    const [mines, setMines] = useState();
    const [exec, setExec] = useState(false)
    const [vp,setVp]=useState(0)
    const assignPackageProps = (package_type) => {
        var amount = '';
        var mine_amount = '';
        var mine_duration = '';
        var referral_bonus = '';
        switch (package_type) {
            case "starter":
                amount = 250;
                mine_amount = 10;
                mine_duration = 1;
                referral_bonus = 600;
                break;

            case "premium":
                amount = 500;
                mine_amount = 40;
                mine_duration = 1;
                referral_bonus = 1250;
                break;

            case "premium pro":
                amount = 750;
                mine_amount = 100;
                mine_duration = 1;
                referral_bonus = 2500
                break;

            case "elite":
                amount = 1000;
                mine_amount = 150;
                mine_duration = 1;
                referral_bonus = 5000
                break;

            case "expert":
                amount = 1250;
                mine_amount = 4800;
                mine_duration = 24;
                referral_bonus = 7500
                break;

            case "worker":
                amount = 1500;
                mine_amount = 6000;
                mine_duration = 24;
                referral_bonus = 12500
                break;
        }
        return { amount, mine_amount, mine_duration, referral_bonus }
    }
    useEffect(() => {
        if (user == null) {

            (async () => {

                const q = query(collection(db, "user"), where("email", "==", user_key));
                const querySnapshot = await getDocs(q);
                querySnapshot.forEach((doc) => {
                    setUser(doc.data())
                    setId(doc.id)
                    localStorage.setItem('user_id', user);
                });

                console.log(user)

            })();

        }
        if (user != null) {
            localStorage.setItem('package', user.package_type);
            // alert('user not equal to null')
            // localStorage.setItem('user_id', user_id);
            if (user.no_logins == 0) {
                (async () => {

                    setTamt(assignPackageProps(user.package_type).amount)
                    setMamt(0)
                    setRamt(0)
                    setRef(0);
                    setMines(0)
                    setShares(0);

                    const userRef = doc(db, "user", user_key);
                    await updateDoc(userRef, {
                        total_balance: assignPackageProps(user.package_type).amount,
                        referal_balance: 0,
                        mine_balance: 0,
                        mine_earning: assignPackageProps(user.package_type).mine_amount,
                        mine_duration: assignPackageProps(user.package_type).mine_duration,
                        referral_bonus: assignPackageProps(user.package_type).referral_bonus,
                        no_logins: user.no_logins + 1,
                        no_referrals: 0,
                        no_shares: 0,
                        no_mines: 0,
                        viral_points:0,
                        mining: false
                    });
                    const notification_data = {
                        type: "earnings",
                        subject: "welcome to Viralclicks mine",
                        body: `You have just been credited with an amount of #${assignPackageProps(user.package_type).amount} as a welcome bonus.`,
                        time: Date.now(),
                        to: user_key
                    }
                    const docRef = await addDoc(collection(db, "notifications"), notification_data)
                })()
            }


            if (user.no_logins > 0 && !exec) {
                (async () => {
                    const q = query(collection(db, "user"), where("email", "==", user_key));
                    const querySnapshot = await getDocs(q);
                    querySnapshot.forEach((doc) => {
                        setUser(doc.data())
                        setId(doc.id)
                    });
                    setRef(user.no_referrals);
                    setMines(user.no_mines);
                    setShares(user.no_shares);
                    setTamt((user.referal_balance) + (user.mine_balance) + assignPackageProps(user.package_type).amount);
                    setRamt(user.referal_balance)
                    setMamt(user.mine_balance);
                    setVp(user.viral_points == undefined ? 0 : user.viral_points)

                    if (user.debit_amount > 0 && user.debit_amount != undefined) {
                        const userRef = doc(db, "user", user_key);
                        const deduction = user.debit_type == "mine" ? { mine_balance: user.mine_balance - user.debit_amount, debit_amount: 0 } : { referal_balance: user.referal_balance - user.debit_amount, debit_amount: 0 }
                        await updateDoc(userRef, deduction);

                    }
                    setExec(true)

                })()

            }
        }
    }, [user]);
    if(user){
        return (

            <div className="dashboard index-parent-container-db utility">
                <Header props={{ initial: user_key[0].toUpperCase(), package: user.package_type }} />
                <BaseNav active={"Overview"} />
                <div className="container">
                    <div className="cards-container grid">
                        <div className="card">
                            <h3>Total Amount</h3>
                            <h1><span>₦</span> {t_amt}</h1>
                        </div>
                            
                         <div className="card">
                            <h3>Viralpoints</h3>
                            <h1><span></span> {vp > 1 ? `${vp} vpts`: ` ${vp} vpt`}</h1>
                        </div>
                        <div className="card">
                            <h3>Mine Amount</h3>
                            <h1><span>₦</span> {mine_amt}</h1>
                        </div>
                        <div className="card">
                            <h3>Referral Bonus</h3>
                            <h1><span>₦</span> {ref_amt}</h1>
                        </div>
                        <div className="card">
                            <h3>Referrals</h3>
                            <h1>{ref}</h1>
                        </div>
                        <div className="card">
                            <h3>Mines</h3>
                            <h1>{mines}</h1>
                        </div>
                        <div className="card">
                            <h3>Shares</h3>
                            <h1>{shares}</h1>
                        </div>

                    </div>
                </div>
                

                <Footer />
            </div>



        );
    } else {
        return (
            <div className="dashboard loader-container">
                <div className="loader-header bg-w">
                    <div className="container">
                        <div className="loader-header-top loader-element"></div>
                        <div className="loader-header-bottom loader-element"></div>
                    </div>
                </div>
                <div className="loader-main bg-ws">
                   <div className="container">
                      <div className="loader-cards grid">
                          <div className="loader-card loader-element"> </div>
                          <div className="loader-card loader-element"> </div>
                          <div className="loader-card loader-element"> </div>
                          <div className="loader-card loader-element"> </div>
                          <div className="loader-card loader-element"> </div>
                          <div className="loader-card loader-element"> </div>
                      </div>
                      <div className="loader-analytics loader-element"> </div>
                   </div>
                </div>
            </div>

        );
    }
}

export default Index;
